// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/account/v1/portal_service.proto (package spwn.account.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3 } from "@bufbuild/protobuf";
import { PortalAccountCoreFan, PortalBrand, PortalBrandCore, PortalDMBrand, PortalDMUser, PortalFan, PortalTenant, PortalUser } from "./portal_common_pb";
/**
 * @generated from message spwn.account.v1.PortalAccountServiceRegisterUserRequest
 */
export class PortalAccountServiceRegisterUserRequest extends Message {
    constructor(data) {
        super();
        /**
         * 名前
         *
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * メールアドレス
         *
         * @generated from field: string email = 3;
         */
        this.email = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceRegisterUserRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceRegisterUserRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceRegisterUserRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceRegisterUserRequest, a, b);
    }
}
PortalAccountServiceRegisterUserRequest.runtime = proto3;
PortalAccountServiceRegisterUserRequest.typeName = "spwn.account.v1.PortalAccountServiceRegisterUserRequest";
PortalAccountServiceRegisterUserRequest.fields = proto3.util.newFieldList(() => [
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceRegisterUserResponse
 */
export class PortalAccountServiceRegisterUserResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceRegisterUserResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceRegisterUserResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceRegisterUserResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceRegisterUserResponse, a, b);
    }
}
PortalAccountServiceRegisterUserResponse.runtime = proto3;
PortalAccountServiceRegisterUserResponse.typeName = "spwn.account.v1.PortalAccountServiceRegisterUserResponse";
PortalAccountServiceRegisterUserResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "user", kind: "message", T: PortalUser },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceUpdateUserRequest
 */
export class PortalAccountServiceUpdateUserRequest extends Message {
    constructor(data) {
        super();
        /**
         * 名前
         *
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * メールアドレス
         *
         * @generated from field: string email = 3;
         */
        this.email = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceUpdateUserRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceUpdateUserRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceUpdateUserRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceUpdateUserRequest, a, b);
    }
}
PortalAccountServiceUpdateUserRequest.runtime = proto3;
PortalAccountServiceUpdateUserRequest.typeName = "spwn.account.v1.PortalAccountServiceUpdateUserRequest";
PortalAccountServiceUpdateUserRequest.fields = proto3.util.newFieldList(() => [
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceUpdateUserResponse
 */
export class PortalAccountServiceUpdateUserResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceUpdateUserResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceUpdateUserResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceUpdateUserResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceUpdateUserResponse, a, b);
    }
}
PortalAccountServiceUpdateUserResponse.runtime = proto3;
PortalAccountServiceUpdateUserResponse.typeName = "spwn.account.v1.PortalAccountServiceUpdateUserResponse";
PortalAccountServiceUpdateUserResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "user", kind: "message", T: PortalUser },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetFanByFirestoreIdRequest
 */
export class PortalAccountServiceGetFanByFirestoreIdRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_firestore_id = 1;
         */
        this.userFirestoreId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetFanByFirestoreIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetFanByFirestoreIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetFanByFirestoreIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceGetFanByFirestoreIdRequest, a, b);
    }
}
PortalAccountServiceGetFanByFirestoreIdRequest.runtime = proto3;
PortalAccountServiceGetFanByFirestoreIdRequest.typeName = "spwn.account.v1.PortalAccountServiceGetFanByFirestoreIdRequest";
PortalAccountServiceGetFanByFirestoreIdRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetFanByFirestoreIdResponse
 */
export class PortalAccountServiceGetFanByFirestoreIdResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetFanByFirestoreIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetFanByFirestoreIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetFanByFirestoreIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceGetFanByFirestoreIdResponse, a, b);
    }
}
PortalAccountServiceGetFanByFirestoreIdResponse.runtime = proto3;
PortalAccountServiceGetFanByFirestoreIdResponse.typeName = "spwn.account.v1.PortalAccountServiceGetFanByFirestoreIdResponse";
PortalAccountServiceGetFanByFirestoreIdResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "fan", kind: "message", T: PortalFan },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetMeRequest
 */
export class PortalAccountServiceGetMeRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetMeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetMeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetMeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceGetMeRequest, a, b);
    }
}
PortalAccountServiceGetMeRequest.runtime = proto3;
PortalAccountServiceGetMeRequest.typeName = "spwn.account.v1.PortalAccountServiceGetMeRequest";
PortalAccountServiceGetMeRequest.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetMeResponse
 */
export class PortalAccountServiceGetMeResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetMeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetMeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetMeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceGetMeResponse, a, b);
    }
}
PortalAccountServiceGetMeResponse.runtime = proto3;
PortalAccountServiceGetMeResponse.typeName = "spwn.account.v1.PortalAccountServiceGetMeResponse";
PortalAccountServiceGetMeResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "fan", kind: "message", T: PortalFan },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetFanByEmailRequest
 */
export class PortalAccountServiceGetFanByEmailRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string email = 1;
         */
        this.email = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetFanByEmailRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetFanByEmailRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetFanByEmailRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceGetFanByEmailRequest, a, b);
    }
}
PortalAccountServiceGetFanByEmailRequest.runtime = proto3;
PortalAccountServiceGetFanByEmailRequest.typeName = "spwn.account.v1.PortalAccountServiceGetFanByEmailRequest";
PortalAccountServiceGetFanByEmailRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetFanByEmailResponse
 */
export class PortalAccountServiceGetFanByEmailResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetFanByEmailResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetFanByEmailResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetFanByEmailResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceGetFanByEmailResponse, a, b);
    }
}
PortalAccountServiceGetFanByEmailResponse.runtime = proto3;
PortalAccountServiceGetFanByEmailResponse.typeName = "spwn.account.v1.PortalAccountServiceGetFanByEmailResponse";
PortalAccountServiceGetFanByEmailResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "fan", kind: "message", T: PortalFan },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetBrandByIdRequest
 */
export class PortalAccountServiceGetBrandByIdRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetBrandByIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetBrandByIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetBrandByIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceGetBrandByIdRequest, a, b);
    }
}
PortalAccountServiceGetBrandByIdRequest.runtime = proto3;
PortalAccountServiceGetBrandByIdRequest.typeName = "spwn.account.v1.PortalAccountServiceGetBrandByIdRequest";
PortalAccountServiceGetBrandByIdRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetBrandByIdResponse
 */
export class PortalAccountServiceGetBrandByIdResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetBrandByIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetBrandByIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetBrandByIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceGetBrandByIdResponse, a, b);
    }
}
PortalAccountServiceGetBrandByIdResponse.runtime = proto3;
PortalAccountServiceGetBrandByIdResponse.typeName = "spwn.account.v1.PortalAccountServiceGetBrandByIdResponse";
PortalAccountServiceGetBrandByIdResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "brand", kind: "message", T: PortalBrand },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetBrandByFirestoreIdRequest
 */
export class PortalAccountServiceGetBrandByFirestoreIdRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_firestore_id = 1;
         */
        this.brandFirestoreId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetBrandByFirestoreIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetBrandByFirestoreIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetBrandByFirestoreIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceGetBrandByFirestoreIdRequest, a, b);
    }
}
PortalAccountServiceGetBrandByFirestoreIdRequest.runtime = proto3;
PortalAccountServiceGetBrandByFirestoreIdRequest.typeName = "spwn.account.v1.PortalAccountServiceGetBrandByFirestoreIdRequest";
PortalAccountServiceGetBrandByFirestoreIdRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "brand_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetBrandByFirestoreIdResponse
 */
export class PortalAccountServiceGetBrandByFirestoreIdResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetBrandByFirestoreIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetBrandByFirestoreIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetBrandByFirestoreIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceGetBrandByFirestoreIdResponse, a, b);
    }
}
PortalAccountServiceGetBrandByFirestoreIdResponse.runtime = proto3;
PortalAccountServiceGetBrandByFirestoreIdResponse.typeName = "spwn.account.v1.PortalAccountServiceGetBrandByFirestoreIdResponse";
PortalAccountServiceGetBrandByFirestoreIdResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "brand", kind: "message", T: PortalBrandCore },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetTenantByFirestoreIdRequest
 */
export class PortalAccountServiceGetTenantByFirestoreIdRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string tenant_firestore_id = 1;
         */
        this.tenantFirestoreId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetTenantByFirestoreIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetTenantByFirestoreIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetTenantByFirestoreIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceGetTenantByFirestoreIdRequest, a, b);
    }
}
PortalAccountServiceGetTenantByFirestoreIdRequest.runtime = proto3;
PortalAccountServiceGetTenantByFirestoreIdRequest.typeName = "spwn.account.v1.PortalAccountServiceGetTenantByFirestoreIdRequest";
PortalAccountServiceGetTenantByFirestoreIdRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "tenant_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetTenantByFirestoreIdResponse
 */
export class PortalAccountServiceGetTenantByFirestoreIdResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetTenantByFirestoreIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetTenantByFirestoreIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetTenantByFirestoreIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceGetTenantByFirestoreIdResponse, a, b);
    }
}
PortalAccountServiceGetTenantByFirestoreIdResponse.runtime = proto3;
PortalAccountServiceGetTenantByFirestoreIdResponse.typeName = "spwn.account.v1.PortalAccountServiceGetTenantByFirestoreIdResponse";
PortalAccountServiceGetTenantByFirestoreIdResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "tenant", kind: "message", T: PortalTenant },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetDMAccountsRequest
 */
export class PortalAccountServiceGetDMAccountsRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetDMAccountsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetDMAccountsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetDMAccountsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceGetDMAccountsRequest, a, b);
    }
}
PortalAccountServiceGetDMAccountsRequest.runtime = proto3;
PortalAccountServiceGetDMAccountsRequest.typeName = "spwn.account.v1.PortalAccountServiceGetDMAccountsRequest";
PortalAccountServiceGetDMAccountsRequest.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetDMAccountsResponse
 */
export class PortalAccountServiceGetDMAccountsResponse extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.account.v1.PortalDMBrand brands = 2;
         */
        this.brands = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetDMAccountsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetDMAccountsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetDMAccountsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceGetDMAccountsResponse, a, b);
    }
}
PortalAccountServiceGetDMAccountsResponse.runtime = proto3;
PortalAccountServiceGetDMAccountsResponse.typeName = "spwn.account.v1.PortalAccountServiceGetDMAccountsResponse";
PortalAccountServiceGetDMAccountsResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "user", kind: "message", T: PortalDMUser },
    { no: 2, name: "brands", kind: "message", T: PortalDMBrand, repeated: true },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest
 */
export class PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        /**
         * @generated from field: string user_id = 2;
         */
        this.userId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest, a, b);
    }
}
PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest.runtime = proto3;
PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest.typeName = "spwn.account.v1.PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest";
PortalAccountServiceGetCoreFanByBrandIdAndUserIdRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse
 */
export class PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse, a, b);
    }
}
PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse.runtime = proto3;
PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse.typeName = "spwn.account.v1.PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse";
PortalAccountServiceGetCoreFanByBrandIdAndUserIdResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "core_fan", kind: "message", T: PortalAccountCoreFan },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceSaveUserMemoRequest
 */
export class PortalAccountServiceSaveUserMemoRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        /**
         * @generated from field: string user_id = 2;
         */
        this.userId = "";
        /**
         * @generated from field: string memo = 3;
         */
        this.memo = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceSaveUserMemoRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceSaveUserMemoRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceSaveUserMemoRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceSaveUserMemoRequest, a, b);
    }
}
PortalAccountServiceSaveUserMemoRequest.runtime = proto3;
PortalAccountServiceSaveUserMemoRequest.typeName = "spwn.account.v1.PortalAccountServiceSaveUserMemoRequest";
PortalAccountServiceSaveUserMemoRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "memo", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceSaveUserMemoResponse
 */
export class PortalAccountServiceSaveUserMemoResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceSaveUserMemoResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceSaveUserMemoResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceSaveUserMemoResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceSaveUserMemoResponse, a, b);
    }
}
PortalAccountServiceSaveUserMemoResponse.runtime = proto3;
PortalAccountServiceSaveUserMemoResponse.typeName = "spwn.account.v1.PortalAccountServiceSaveUserMemoResponse";
PortalAccountServiceSaveUserMemoResponse.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest
 */
export class PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest, a, b);
    }
}
PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest.runtime = proto3;
PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest.typeName = "spwn.account.v1.PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest";
PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdRequest.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.account.v1.PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse
 */
export class PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated string brand_firestore_ids = 1;
         */
        this.brandFirestoreIds = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse, a, b);
    }
}
PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse.runtime = proto3;
PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse.typeName = "spwn.account.v1.PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse";
PortalAccountServiceGetCoreFanBrandFirestoreIdsByUserIdResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "brand_firestore_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
//# sourceMappingURL=portal_service_pb.js.map